import { css } from '@emotion/css';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Colors } from '../../shared/styles/colors';
import { p2Style } from '../../shared/styles/text';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '../../shared/components/Button';
import { useNavigator } from '../../routing/navigator';
import { Radius } from '../../shared/styles/tokens';

export const PaymentInfoTextCharter = (): JSX.Element => {
  return (
    <div className={infoContainerStyle}>
      <InformationCircleIcon className={iconStyle} aria-hidden="true" />
      <p className={infoTextStyle}>
        You can pay at the front desk using cash or card.
      </p>
    </div>
  );
};

export const HowToAddMoneyText = (): JSX.Element => {
  const navigator = useNavigator();
  return (
    <div className={infoContainerStyle}>
      <InformationCircleIcon className={iconStyle} aria-hidden="true" />
      <div>
        <p className={infoTextStyle}>
          You can add money to your account at the front desk or you can try
          adding money in the wallet screen.
        </p>
        <Button
          variant={ButtonVariantEnum.TEXT}
          size={ButtonSizeEnum.MEDIUM}
          text={'Open Wallet'}
          onClick={() => navigator.toWallet()}
        />
      </div>
    </div>
  );
};

export const PaymentInfoTextPostpaid = (): JSX.Element => {
  return (
    <div className={infoContainerStyle}>
      <InformationCircleIcon className={iconStyle} aria-hidden="true" />
      <p className={infoTextStyle}>
        You can also pay at the front desk using cash or card.
      </p>
    </div>
  );
};

export const NoAccountText = (): JSX.Element => {
  return (
    <div className={noAccountTextStyle}>
      <p className={infoTextStyle}>
        {`You don't have an account for this marina.`}
      </p>
    </div>
  );
};

const infoContainerStyle = css`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 0.875rem 1rem;
  background: ${Colors.CAPRI_BLUE_TINT};
  border-radius: ${Radius.md};
`;
const iconStyle = css`
  width: 1.5rem;
  flex: 0 0 auto;
  color: ${Colors.CAPRI_BLUE};
`;
const infoTextStyle = css`
  ${p2Style}
`;

const noAccountTextStyle = css`
  margin-bottom: 2rem;
`;
